import { Loader } from "Components/General/Loader";
import { I18N_NS } from "Config/i18n";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { staIntegrationStore } from "Stores/StaIntegrationStore";
import { notificationError, notificationSuccess } from "utils/libHelpers/AntdNotification";

export const StaCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { projectId } = useParams<{ projectId: string }>();
  const { t } = useTranslation(I18N_NS.PROJECT);
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) {
      return;
    }

    const handleCallback = async () => {
      const companyCode = searchParams.get("companyCode");
      const userGuid = searchParams.get("userGuid");

      if (!projectId || !companyCode || !userGuid) {
        notificationError(t("Error"), t("STA account linking failed. Missing required parameters."));
        navigate("/dashboard");
        return;
      }

      handledRef.current = true;

      try {
        await staIntegrationStore.saveUserLink(+projectId, companyCode, userGuid);
        notificationSuccess(t("Success"), t("Your STA account has been linked successfully."));
        staIntegrationStore.finishLinkCallback(projectId, navigate);
      } catch (error) {
        notificationError(t("Error"), t("STA account linking failed. Please try again."));
        staIntegrationStore.finishLinkCallback(projectId, navigate);
        throw error;
      }
    };

    handleCallback();
  }, [navigate, projectId, searchParams, t]);

  return <Loader style={{ marginTop: "15%" }} />;
};
